export const SKU_SEPARATOR = '|.|'
export const EMAIL_PATTERN = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
export const NAMES_PATTERN = new RegExp(/^[a-zA-Z\' ]{2,}$/)
